// @ts-check
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Icon from './Icon';

function removeSubOptionsFromValue(value, options, subOptionsKey, valueKey) {
  let newValue = value;
  if (options) {
    const values = options.map(option => option[valueKey]);
    newValue = _.without(newValue, ...values);
    options.forEach(option => {
      newValue = removeSubOptionsFromValue(
        newValue,
        option[subOptionsKey],
        subOptionsKey,
        valueKey
      );
    });
  }
  return newValue;
}

class MultiTreeSelect extends Component {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  onClick(e, option) {
    e.stopPropagation();
    e.preventDefault();

    const { value, onChange, clickable, subOptionsKey, valueKey } = this.props;
    if (!clickable) {
      return;
    }
    const checked = _.indexOf(value, option[valueKey]) >= 0;
    if (checked) {
      onChange(_.without(value, option[valueKey]));
    } else {
      let newValue = value.concat(option[valueKey]);
      newValue = removeSubOptionsFromValue(
        newValue,
        option[subOptionsKey],
        subOptionsKey,
        valueKey
      );
      onChange(newValue);
    }
  }

  render() {
    const {
      options,
      value,
      onChange,
      clickable,
      subOptionsKey,
      labelKey,
      valueKey,
      selectableKey,
      selectablePredicate,
    } = this.props;

    return (
      <ul className="MultiTreeSelect">
        {options.map(option => {
          const selectable = selectableKey ? option[selectableKey] : selectablePredicate(option);
          const checked = _.indexOf(value, option[valueKey]) >= 0;
          return (
            <li key={option[valueKey]} className={checked ? 'checked' : 'unchecked'}>
              {checked ? (
                <span className="checked-indicator">
                  <Icon name="check-circle" />
                </span>
              ) : null}
              {!checked && !selectable ? (
                <span className="parent-checked-indicator">
                  <Icon name="checkmark" />
                </span>
              ) : null}
              <span
                className={selectable ? 'selectable' : ''}
                onClick={selectable ? e => this.onClick(e, option) : null}
              >
                {option[labelKey]}
              </span>
              {option[subOptionsKey] ? (
                <MultiTreeSelect
                  {...this.props}
                  clickable={clickable && !checked}
                  options={option[subOptionsKey]}
                  value={value}
                  onChange={onChange}
                />
              ) : null}
            </li>
          );
        })}
      </ul>
    );
  }
}

MultiTreeSelect.displayName = 'MultiTreeSelect';

MultiTreeSelect.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  clickable: PropTypes.bool.isRequired,
  subOptionsKey: PropTypes.string.isRequired,
  valueKey: PropTypes.string.isRequired,
  labelKey: PropTypes.string.isRequired,
  selectableKey: PropTypes.string,
  selectablePredicate: PropTypes.func,
};

MultiTreeSelect.defaultProps = {
  clickable: true,
  subOptionsKey: 'subOptions',
  labelKey: 'label',
  valueKey: 'value',
  selectablePredicate: () => true,
};

export default MultiTreeSelect;
